import lecin from 'assets/csr/companies/lecin.jpeg'
import teach from 'assets/csr/companies/teach.png'
import Srijan1 from 'assets/csr/companies/Srijan1.png'
import Srijan2 from 'assets/csr/companies/Srijan2.png'
import Srijan3 from 'assets/csr/companies/Srijan3.png'
import bg from 'assets/cropAssure/management/bg.png'
import Partition from 'molecules/partition'
import CsrManagement from 'organisms/csrManagement'

interface CSR {
  title: string
  para1: JSX.Element
  para2?: JSX.Element
  extras?: JSX.Element
  image: string
}

interface CSRYearGroup {
  year: string
  items: CSR[]
}

const csrData: CSRYearGroup[] = [
  {
  year: 'FY 2025–26',
  items: [
      {
        title: 'BharatRohan Srijan Kendra',
        para1: (
          <div className="space-y-4">
            <p>Creating Equal Learning Opportunities for Rural Children</p>

            <p>
              A child’s first learning experiences shape how they see the world
              and their place in it. Curiosity, confidence and the courage to ask
              questions often begin long before formal schooling starts.
            </p>

            <p>
              In many rural communities, children grow up with immense potential
              but limited exposure to structured early learning, scientific
              exploration and confidence-building environments.
              These early gaps can make the transition to school challenging and
              slow down a child’s ability to engage, express, and explore.
            </p>

            {/* <p>
              
            </p> */}

            <p>BharatRohan Srijan Kendra is created to change that story.</p>
          </div>
        ),
        image: Srijan1,
      },

      {
        title: 'How Learning Happens at Srijan Kendra',
        para1: (
          <div className="space-y-4">
            <p>
              Initiated by BharatRohan Innovation Foundation, the CSR arm of
              BharatRohan, in partnership with LECIN, Srijan Kendra is designed
              as a joyful, safe, and inclusive space where early learning feels
              natural, exciting, and empowering.
            </p>

            <p>
              Here, children are introduced to structured thinking and basic
              scientific concepts through play, hands-on activities, and
              real-world exploration. Learning is designed to spark curiosity
              not fear and to encourage questions, creativity, and
              problem-solving from the very beginning.
            </p>

            <p>
              At Srijan Kendra, children learn by doing. They observe,
              experiment, communicate, and collaborate, which builds not just
              academic readiness, but emotional and social confidence as well.
              Each activity is age-appropriate, experiential and rooted in the
              belief that every child learns best when they feel supported and
              valued.
            </p>
          </div>
        ),
        image: Srijan2,
      },

      {
        title: 'Our Focus at Srijan Kendra',
        para1: (
          <ul className="list-disc pl-6 space-y-3">
            <li>
              Strengthening foundational learning skills for a smooth transition
              into formal education
            </li>
            <li>
              Preparing children emotionally, socially, and academically for
              school life
            </li>
            <li>
              Introducing scientific thinking through simple, engaging,
              hands-on experiences
            </li>
            <li>
              Building confidence, communication skills, and natural curiosity
            </li>
            {/* <li>
              Creating a nurturing environment where children feel safe to
              explore and express
            </li> */}
          </ul>
        ),
        extras: (
          <div className="space-y-4 mt-6">
            <p>
              By bridging early learning gaps and encouraging hands-on
              exploration, Srijan Kendra equips children with essential skills
              and a resilient mindset, helping them step into school and life
              with confidence. This initiative reflects BharatRohan’s commitment to inclusive
              growth, where education becomes a powerful pathway to equal
              opportunity and long-term empowerment in rural communities.
            </p>

            {/* <p>
              
            </p> */}
          </div>
        ),
        image: Srijan3,
      },
    ],
  },
  {
    year: 'FY 2024–25',
    items: [
      {
        title: 'TEACH (Training and Educational Centre for Hearing Impaired)',
        para1: (
          <p>
            For individuals with hearing impairments, education and employment
            opportunities remain limited. TEACH bridges this gap by providing
            specialized education and industry-relevant skills.
          </p>
        ),
        para2: (
          <p>
            TEACH focuses on mental well-being, sign language proficiency, and
            employer sensitization, fostering an inclusive ecosystem.
          </p>
        ),
        image: teach,
      },
      {
        title: 'LECIN (Let’s Educate Children In Need) – Project NEEV',
        para1: (
          <p>
            Every child deserves a strong educational foundation. Project NEEV
            strengthens early childhood learning by equipping children with
            literacy, numeracy, and social-emotional skills.
          </p>
        ),
        para2: (
          <p>
            The program trains local educators, empowers women as facilitators,
            and actively involves parents.
          </p>
        ),
        image: lecin,
      },
    ],
  },
]

const CsrOrganizations = () => {
  return (
    <section className="bg-cream3 relative">
      <img
        src={bg}
        alt="plants"
        className="absolute bottom-3 right-0 hidden h-28 w-auto opacity-[15%] lg:h-32 2xl:h-40 md:block min-[1800px]:h-60"
      />

      <section className="py-16 px-4 w-container sm:w-container-sm md:w-container">
        <Partition color="dark" text="Partnered Organizations" />
        <div className="pb-8" />

        {csrData.map((yearGroup) => (
          <div key={yearGroup.year} className="mt-20">
            <h2 className="text-3xl font-semibold text-green mb-12">
              {yearGroup.year}
            </h2>

            {yearGroup.items.map((item, index) => (
              <div key={item.title} className={index > 0 ? 'mt-20' : ''}>
                <CsrManagement
                  title={<span className="text-green">{item.title}</span>}
                  para1={item.para1}
                  para2={item.para2}
                  extras={item.extras}
                  image={item.image}
                  imageAlign={index % 2 === 0 ? 'right' : 'left'}
                />
              </div>
            ))}
          </div>
        ))}
      </section>
    </section>
  )
}

export default CsrOrganizations
